import { Capacitor } from '@capacitor/core';

/**
 * Checks if the project is built as a Capacitor app and is currently running on iOS.
 */
export const isApplicationRunningOniOS = () => Capacitor.getPlatform() === 'ios';
